import VBanner from './VBanner';
export { VBanner };
export default VBanner;
//# sourceMappingURL=index.js.map